import { render, staticRenderFns } from "./pubDelicacy.vue?vue&type=template&id=525a0fbc&scoped=true&"
import script from "./pubDelicacy.vue?vue&type=script&lang=js&"
export * from "./pubDelicacy.vue?vue&type=script&lang=js&"
import style0 from "./pubDelicacy.vue?vue&type=style&index=0&id=525a0fbc&prod&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "525a0fbc",
  null
  
)

export default component.exports